<template>
    <eSesjaModal>
        <eSesjaModalHeader @close="$store.commit('setRecorderSelectSessionModalStatus', false)">
            {{$t('com.file.nav-data.sessions')}}
        </eSesjaModalHeader>
        <eSesjaModalBody>

            <label class="esesja-modal__wraper__body__label">{{$t('com.file.select-session-modal.select-session')}}</label>
            <section class="esesja-modal__row">
                <select class="esesja-modal__wraper__body__input" v-model="selectedSession">
                    <option v-for="(item, index) in allSessiosn" :key="index" :value="item">[{{item.id}}] {{ getPublicSessionName(item) }} z dnia {{formatDateToDisplay(item.meeting_date)}}</option>
                </select>
            </section>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="$store.commit('setRecorderSelectSessionModalStatus', false)">
                {{$t('com.global.cancel')}}
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave @click="proceed">
                {{$t('com.global.select')}}
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>
<script charset="utf-8">
    import { getPublicSessionName } from '../../../../../helpers/session.helper';
    export default {
        name: "SelectSessionModal",
        emits: ["selectedSession"],
        props: {
            currentSessionId: {
                type: Number,
                default: -1,
            }
        },
        computed: {
            allSessiosn() {
                return this.$store.state.appStore.groups
                    .map(item => {
                        let sessions = [ ...item.sessions ];
                        return sessions.map(session => { 
                            session.default_session_number_format = item.session_number_format_id;
                            session.default_group_name = item.session_default_name;
                            return session;
                        });
                    })
                    .flat()
            }
        },
        mounted() {
            try {
                let filtered = this.allSessiosn.filter(item => item.id === this.currentSessionId);

                if (filtered.length !== 1) {
                    return;
                } 

                this.selectedSession = filtered[0];
            }
            catch {
                console.log("err");
            }
        },
        data() {
            return {
                selectedSession: {},
            } 
        },
        methods: {
            proceed() {
                this.$emit('selectedSession', this.selectedSession);
                this.$store.commit('setRecorderSelectSessionModalStatus', false);
            },
            formatDateToDisplay(value) {
                var date = new Date(value)
                var d = date.toLocaleString('default', {
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric'
                });

                return d;
            },
            getPublicSessionName,
        }

    }
</script>